import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import PrivateRoute from './privateRoute.js';

import { Home, Login } from '../pages';

export default function Routes() {
  return (
    <Router>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/login/*" component={Login} />
        <Route exact path="/recuperarsenha" component={Login} />
        <Route exact path="/alterarsenha" component={Login} />
        <Route exact path="/" component={Login} />
        <PrivateRoute exact path="/home" component={Home} />
      </Switch>
    </Router>
  );
}
